import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import cardHistoryImage01 from "@/assets/images/help/card-history-01.png";
import cardHistoryImage02 from "@/assets/images/help/card-history-02.png";

export default function HelpCardHistory() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-9">
          <h1 className="text-[32px] font-bold leading-[1.6] opacity-80">
            View Your Fellas Card Transaction History
          </h1>
        </div>

        {/* Content */}
        <div className="space-y-9">
          {/* Introduction */}
          <div className="space-y-4">
            <p className="text-base font-bold leading-[1.6] opacity-70 whitespace-pre-line">
              All transactions made with your Fellas Card can be viewed on the
              Fellas Card website.
              {"\n\n"}Regularly checking your transaction history helps you
              manage your card and assets more securely.
            </p>
          </div>

          {/* Step 1 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">Step 1: Open History</h3>
            <p className="text-base font-bold leading-[1.6] opacity-70">
              Go to More → Menu and click the "History" button to access the
              History screen.
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={cardHistoryImage01}
                alt="Card History Step 1"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 2 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">Step 2: View Transactions</h3>
            <p className="text-base font-bold leading-[1.6] opacity-70 whitespace-pre-line">
              All transactions, including card payments and top-ups, are
              displayed by date.
              {"\n\n"}You can check the amount, time, and status of each
              transaction.
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={cardHistoryImage02}
                alt="Card History Step 2"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>

        {/* Next Step */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help/15")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Next: View Profile</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
